var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndiana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.3,193.015c0,0,0.912,10.926,0,14.565c-0.909,3.643-14.261,25.491-15.777,27.615c-1.237,1.731-0.459,14.739-0.13,19.499 l30.475-5.538c0,0,6.982,8.495,8.192,7.282c1.214-1.215,0.304-7.384,2.428-8.699c2.125-1.316,8.497-5.261,8.497-5.261l7.891,7.039 h4.249c0,0-2.428-8.253,0-8.859c2.428-0.609,10.317-7.282,10.317-7.282l1.819,4.854l10.016-0.303c0,0-0.305-7.283,2.73-10.318 c3.033-3.035,19.723-19.422,19.723-19.422v-10.316h6.982c0,0,18.51-5.16,16.992-9.713c-1.517-4.551-6.371-10.619-3.644-12.139 L189.588,33.707l-0.91-3.955l-80.417,6.979L91.975,47.454l-10.016-5.259c0,0,7.791,141.108,7.791,142.323 C89.75,185.73,94.3,193.015,94.3,193.015z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiana);
export default __webpack_public_path__ + "static/media/indiana.2e9830806a3aa126f5e39788144461b0.svg";
export { ForwardRef as ReactComponent };